import React, { useState } from 'react';
import classNames from 'classnames'
import DropdownOption from './DropdownOption';
import FieldError from './FieldError';

function DropdownField({field, displayErrors}) {

  const placeholder = field.label + (field.required ? ' *': '')
  const error = field.error[0];
  const [isOpen, setOpen] = useState(false);
  const onOptionClicked = value => () => {
    field.property[1](value);
    setOpen(false);
  };

  return (
    <div className="o-form-fieldset o-form-label-top">
      <div className={classNames('o-form-input', { 'o-form-has-errors': true })}>
        <span className={classNames('o-form-select', 'o-form-input-name-activate_on_login', 'o-form-control', { 'o-form-has-errors': true })}>
          <div className="chzn-container chzn-container-single chzn-with-drop" style={{width: "100%"}}>
            <a href="#" onClick={(e) => {e.preventDefault(); setOpen(!isOpen);}} className="chzn-single"><span>{field.choices[field.property[0]] || placeholder}</span>
              <div><b></b></div>
            </a>
            {isOpen && (
              <div className="chzn-drop">
                <ul className="chzn-results" style={{display: "block"}}>
                  {Object.keys(field.choices).map((code, index) => (
                    <DropdownOption key={index} setter={onOptionClicked(code)} code={code} label={field.choices[code]} />
                  ))}
                </ul>
              </div>
            )}
          </div>
        </span>
        {error && displayErrors && (
          <FieldError msg={error}/>
        )}
      </div>
    </div>
  )
}

export default DropdownField;
